import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { mscGet, mscSet, store } from '@msc-b2c/shared-utils';

import { initMscStorageCompliance } from './lib/init';

import App from './app/app';

let storageComplianceInitialized = false;
const tryInitStorageCompliance = () => {
  const enabled =
    store.getState().genericConfigs?.configs?.b2cCommerceConfig?.cookieComplianceEnabled;

  if (enabled && !storageComplianceInitialized) {
    storageComplianceInitialized = true;
    initMscStorageCompliance();
  }
};

// Redux may hydrate after this module executes; subscribe so we initialize once the flag arrives.
tryInitStorageCompliance();
let unsubscribe: (() => void) | undefined = store.subscribe(() => {
  tryInitStorageCompliance();
  if (storageComplianceInitialized && unsubscribe) unsubscribe();
});

const root = document.createElement('div');
root.id = 'storage-compliance-root';

document.body.appendChild(root);
const reactRoot = ReactDOM.createRoot(root as HTMLElement);

const onDocumentReady = () => {
  if (!mscGet<string>('session', 'tabId')) {
    mscSet('session', 'tabId', Math.random().toString(36).substring(2, 11));
  }

  reactRoot.render(
    <Provider store={store}>
      <StrictMode>
        <App />
      </StrictMode>
    </Provider>
  );
};

if (document.readyState !== 'loading') {
  onDocumentReady();
} else {
  document.addEventListener('DOMContentLoaded', onDocumentReady);
}
